import { createContext, useContext } from 'react'

import { EditingUserRender } from './bpmn-diagram.types'

/**
 * Collaboration presence, keyed by node id — provided by the canvas from the
 * host's CollaborationService polling and consumed by BpmnFlowNode to render the
 * per-node editing-user bubbles. A
 * context keeps the 10s polling updates from re-syncing the whole nodes array.
 */
export type EditingUsersByNode = Record<number, EditingUserRender[]>

export const EditingUsersContext = createContext<EditingUsersByNode>({})

export function useNodeEditingUsers(nodeId: number): EditingUserRender[] {
  return useContext(EditingUsersContext)[nodeId] ?? []
}
